export const SESSION_FOR_CODE_HEADER_KEY = 'X-BEELINE-SESSION-FOR-CODE';
export const JWT_STORAGE_KEY = 'sessionConfig.jwt';
export const XSRF_TOKEN_STORAGE_KEY = 'sessionConfig.xsrf-token';
